"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attemptFoldersFetch = attemptFoldersFetch;
exports.receiveFoldersFetch = receiveFoldersFetch;
exports.failFoldersFetch = failFoldersFetch;
exports.fetchFolders = fetchFolders;
exports.receiveFolderDelete = receiveFolderDelete;
exports.receiveRenameFolder = receiveRenameFolder;
exports.recieveAddFolder = recieveAddFolder;
exports.addFolder = addFolder;

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = _interopRequireDefault(require("FileManagerCore/actions/ActionTypes"));

var _Constants = require("FileManagerCore/Constants");

var _Folders = require("FileManagerCore/api/Folders");

var MAX_FOLDER_COUNT = 50000;
var MAX_RECURSIVE_REQUESTS = 5;

function attemptFoldersFetch() {
  return {
    type: _ActionTypes.default.FETCH_FOLDERS_ATTEMPTED,
    status: _Constants.RequestStatus.PENDING
  };
}

function receiveFoldersFetch(data) {
  return {
    type: _ActionTypes.default.FETCH_FOLDERS_SUCCEEDED,
    status: _Constants.RequestStatus.SUCCEEDED,
    data: data
  };
}

function failFoldersFetch(error) {
  return {
    type: _ActionTypes.default.FETCH_FOLDERS_FAILED,
    status: _Constants.RequestStatus.FAILED,
    error: error
  };
}

function fetchFolders() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$maxFolderCount = _ref.maxFolderCount,
      maxFolderCount = _ref$maxFolderCount === void 0 ? MAX_FOLDER_COUNT : _ref$maxFolderCount,
      _ref$maxRecursiveRequ = _ref.maxRecursiveRequests,
      maxRecursiveRequests = _ref$maxRecursiveRequ === void 0 ? MAX_RECURSIVE_REQUESTS : _ref$maxRecursiveRequ,
      earlyRequesterPromise = _ref.earlyRequesterPromise;

  return function (dispatch, getState, httpClient) {
    dispatch(attemptFoldersFetch());
    var folders = new _immutable.default.List();
    var recursiveRequestCount = 0;

    var _fetchFolders = function _fetchFolders() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _immutable.default.Map();
      return (0, _Folders.fetch)(options, httpClient, earlyRequesterPromise).then(function (data) {
        folders = folders.concat(data.get('objects'));

        if (data.get('total_count') > folders.count() && folders.count() < maxFolderCount && recursiveRequestCount < maxRecursiveRequests) {
          recursiveRequestCount = recursiveRequestCount + 1;

          _fetchFolders(_immutable.default.Map({
            offset: folders.count()
          }));

          return;
        }

        dispatch(receiveFoldersFetch(data.set('objects', folders)));
      }, function (error) {
        return dispatch(failFoldersFetch(error));
      });
    };

    return _fetchFolders();
  };
}

function receiveFolderDelete(folder) {
  return {
    type: _ActionTypes.default.DELETE_FOLDER_SUCCEEDED,
    folder: folder
  };
}

function receiveRenameFolder(folder) {
  return {
    type: _ActionTypes.default.RENAME_FOLDER_SUCCEEDED,
    folder: folder
  };
}

function recieveAddFolder(folder) {
  return {
    type: _ActionTypes.default.ADD_FOLDER_SUCCEEDED,
    meta: {
      notification: {
        type: 'success',
        titleText: _I18n.default.text('FileManagerCore.notifications.addFolder.success.title'),
        message: _I18n.default.text('FileManagerCore.notifications.addFolder.success.message', {
          folder: folder.get('name')
        })
      }
    },
    folder: folder
  };
}

function addFolder(_ref2) {
  var parentId = _ref2.parentId,
      name = _ref2.name;
  return function (dispatch, getState, httpClient) {
    (0, _Folders.add)({
      parentId: parentId,
      name: name
    }, httpClient).then(function (data) {
      dispatch(recieveAddFolder(data));
    }, function (error) {
      dispatch({
        type: _ActionTypes.default.ADD_FOLDER_FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: _I18n.default.text('FileManagerCore.notifications.addFolder.error.title'),
            message: _I18n.default.text('FileManagerCore.notifications.addFolder.error.message', {
              folder: name
            })
          }
        },
        error: error
      });
    }).done();
  };
}